'use client'
import { permanentRedirect, redirect } from "next/navigation";
import { useEffect } from "react";
import { ProductNavigationLoading } from "../block/ProductNavigation";
import LoadingHeader from "../app/drupal/loading-header";
import { DocumentLoading } from "./document";

export const Redirect = ({ permanent = true, location }: {
  permanent?: boolean;
  location: string;
}) =>  {
    useEffect(() => {
      const hash = window.location.hash;
      // Check if redirect is present and append the section hash at the end of redirect.
      if (permanent) {
        permanentRedirect(location+hash)
      }
      else {
        redirect(location+hash)
      }
    }, [location, permanent])

    return <>
      <ProductNavigationLoading />
      <LoadingHeader title="Redirecting..." />
      <div className="bg-gray-300">
        <div className="container mx-auto group-data-[draw=closed]/body:lg:flex xl:flex gap-12 p-5">
          <DocumentLoading />
        </div>
      </div>
    </>
}